// @flow

export const apiVersion = '98328979ea28302522b1bdee0dc3371cf59bd5d2';

export {
  default as queryMap,
} from 'queries/98328979ea28302522b1bdee0dc3371cf59bd5d2.json';



// WEBPACK FOOTER //
// ./shared/api.js